import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    celularDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_DATOS'(state) {
        state.celularDatos = [];
    },
    'SET_DATOS'(state, celularDatos) {
        state.celularDatos = celularDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    getDatos ( { commit }, celularId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (celularId != 0) {
                apiAxios.get(`bienes/celulares/${celularId}`) 
                    .then(res => {
                        let datos = [
                            // { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'codigo', 'campo': 'Cod.', 'valor': res.data.codigo, 'formato': '' },
                            { 'nombre': 'marcaModelo', 'campo': 'Marca/Modelo', 'valor': res.data.marcaModelo, 'formato': '' },
                            { 'nombre': 'numeroIMEI', 'campo': 'Nro.IMEI', 'valor': res.data.numeroIMEI, 'formato': '' },
                            { 'nombre': 'numero', 'campo': 'Nro.Celular', 'valor': res.data.numero, 'formato': '' },
                            { 'nombre': 'tieneCargador', 'campo': 'Tiene Cargador', 'valor': res.data.tieneCargador? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'rubro', 'campo': 'Rubro', 'valor': res.data.rubro, 'formato': '' },
                            { 'nombre': 'cotizacion', 'campo': 'Cotizacion', 'valor': res.data.cotizacion, 'formato': 'moneda' },
                            { 'nombre': 'pjeAmortizacion', 'campo': 'Pje.Amortizacion', 'valor': res.data.pjeAmortizacion, 'formato': 'porcentaje' },
                            { 'nombre': 'enRevision', 'campo': 'En Revisión', 'valor': res.data.enRevision? 'Si' : 'No', 'formato': '' }
                        ];

                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}